import { createFileRoute } from '@tanstack/react-router';
import { PaymentPlanDetailPage } from 'src/pages/billing/payment-plan-detail';
import { DashboardLayout } from 'src/layouts/dashboard/layout';
import { AuthGuard } from '@onesource/components';

export const Route = createFileRoute('/payment-plans/$paymentPlanId')({
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <PaymentPlanDetailPage />
      </AuthGuard>
    </DashboardLayout>
  ),
});
